import Link from "next/link";
import { Icon } from "src/components/icon/icon";
import { Tooltip } from "src/components/ui-components/Tooltip/Tooltip";
import styles from "../view.module.css";

export default function SearchQueriesButton({
  table_name,
}: {
  table_name: string;
}) {
  return (
    <Tooltip position="above-center" label="Find queries that use this table">
      <Link
        className={styles.iconLink}
        href={`/browse/queries?q=${table_name}&order=favorites&time_range=all&codeSearch=1`}
        target="_blank"
      >
        <Icon icon="search" className={styles.expand} />
      </Link>
    </Tooltip>
  );
}
